import { render, staticRenderFns } from "./RiverWaterRegime.vue?vue&type=template&id=3225943c&scoped=true&"
import script from "./RiverWaterRegime.vue?vue&type=script&lang=js&"
export * from "./RiverWaterRegime.vue?vue&type=script&lang=js&"
import style0 from "./RiverWaterRegime.vue?vue&type=style&index=0&id=3225943c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3225943c",
  null
  
)

export default component.exports